import { render, staticRenderFns } from "./A_error.vue?vue&type=template&id=506f9e3e&scoped=true&"
import script from "./A_error.vue?vue&type=script&lang=js&"
export * from "./A_error.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506f9e3e",
  null
  
)

export default component.exports